/* global PIXI, TWEEN, circle ,rand, smallCircle, menu, deg2rad */

PIXI.utils.skipHello();

const app = new PIXI.Application({
  width: 1920,
  height: 930,
  // width: window.innerWidth,
  // height: window.innerHeight,
  // backgroundColor: null,
  transparent: true,
  resolution: window.devicePixelRation || 1,
  view: document.getElementById('canvas'),
  antialias: true,
});

const ratio = app.renderer.width / 1920;
const mouse = { x: 0, y: 0 };

// 衝出來的粒子 START
const bc1 = new PIXI.Container();
const bc2 = new PIXI.Container();
const bc3 = new PIXI.Container();
const bc4 = new PIXI.Container();
let balls = [];
// const texture1 = app.renderer.generateTexture(circle(0x006edc, 20, '', 0, 0));
// const texture2 = app.renderer.generateTexture(circle(0x55c8fa, 20, '', 0, 0));
// const texture3 = app.renderer.generateTexture(circle(0x003c78, 20, '', 0, 0));
// const texture4 = app.renderer.generateTexture(circle(0x00a0ff, 20, '', 0, 0));

// const renderParticle = (bc, texture, size) => {
//   Array(size).fill(0).forEach(() => {
//     const ball = new PIXI.Sprite(texture);
//     const deg = (Math.random() * 360);
//     const s = rand(0.1, 1.2);
//     ball.scale.set(s);
//     ball.x = app.renderer.width / 2;
//     ball.y = app.renderer.height / 2;
//     ball.alpha = 0;

//     if (deg > 0 && deg < 90) {
//       ball.x += app.renderer.width / 3 * s * rand(0.1, 1.5);
//       ball.y += app.renderer.height / 3 * s * rand(0.1, 1.5);
//     } else if (deg > 90 && deg < 180) {
//       ball.x -= app.renderer.width / 3 * s * rand(0.1, 1.5);
//       ball.y += app.renderer.height / 3 * s * rand(0.1, 1.5);
//     } else if (deg > 180 && deg < 270) {
//       ball.x -= app.renderer.width / 3 * s * rand(0.1, 1.5);
//       ball.y -= app.renderer.height / 3 * s * rand(0.1, 1.5);
//     } else if (deg > 270 && deg < 360) {
//       ball.x += app.renderer.width / 3 * s * rand(0.1, 1.5);
//       ball.y -= app.renderer.height / 3 * s * rand(0.1, 1.5);
//     }

//     const rad = deg2rad(deg);

//     balls.push(ball);
//     bc.addChild(ball);
//     ball.accX = Math.cos(rad) * app.renderer.width / 2000 * ratio;
//     ball.accY = Math.sin(rad) * app.renderer.height / 2000 * ratio;
//   });
// };

// renderParticle(bc1, texture1, 100);
// renderParticle(bc2, texture2, 100);
// renderParticle(bc3, texture3, 100);
// renderParticle(bc4, texture4, 100);

// 衝出來的粒子 END

// const blurFilter = (size) => new PIXI.filters.KawaseBlurFilter(size, 1);
const blurFilter = (size) => new PIXI.filters.BlurFilter(size, 1);

// 主要的球 START

Array.from(menu).forEach((m) => {
  // const X = rand(200, 1800);
  // const Y = rand(200, 700);
  const X = m.position[0];
  const Y = m.position[1];

  const c = new PIXI.Container();
  c.sub = [];
  const centerSize = 50 * m.size * ratio;
  const bigColor = m.color || 0x006edc;
  const bigCircle = circle(bigColor, centerSize, m.name, X, Y);
  let deg = 0;
  if (X >= app.renderer.width / 2 && Y >= app.renderer.height / 2) {
    deg = rand(0, 90);
  } else if (X < app.renderer.width / 2 && Y >= app.renderer.height / 2) {
    deg = rand(90, 180);
  } else if (X < app.renderer.width / 2 && Y < app.renderer.height / 2) {
    deg = rand(180, 270);
  } else {
    deg = rand(270, 360);
  }
  // deg = rand(0, 360)
  bigCircle.originalX = bigCircle.x;
  bigCircle.originalY = bigCircle.y;
  bigCircle.x += 1000 * Math.cos(deg2rad(deg));
  bigCircle.y += 1000 * Math.sin(deg2rad(deg));
  bigCircle.randomX = bigCircle.x;
  bigCircle.randomY = bigCircle.y;
  const item = m;
  item.bc = bigCircle;
  item.bc.sub = [];
  c.addChild(bigCircle);


  Array.from(m.sub).forEach((sub, i) => {
    const size = 30 * sub.size / 80 * centerSize;
    const theta = 360 / (m.sub.length) * ((i + 1) + 10 * rand(-9 / m.sub.length, 9 / m.sub.length));

    // const smallColors = [0x4387f4, 0x88b1fa, 0xf9bb06, 0xbcc7cd, 0x79acfc, 0x5335e63];
    // const smallColor = smallColors[Math.floor(Math.random() * smallColors.length)];
    const smallColor = sub.color;
    const g = smallCircle(smallColor, size, theta, sub.name, centerSize, X, Y, sub.position[0], sub.position[1], sub.fill === false, sub.fontColor);

    let deg = 0;
    if (X >= app.renderer.width / 2 && Y >= app.renderer.height / 2) {
      deg = rand(0, 90);
    } else if (X < app.renderer.width / 2 && Y >= app.renderer.height / 2) {
      deg = rand(90, 180);
    } else if (X < app.renderer.width / 2 && Y < app.renderer.height / 2) {
      deg = rand(180, 270);
    } else {
      deg = rand(270, 360);
    }
    // deg = rand(0, 360)
    g.originalX = g.x;
    g.originalY = g.y;
    g.x += 1000 * Math.cos(deg2rad(deg));
    g.y += 1000 * Math.sin(deg2rad(deg));
    g.randomX = g.x;
    g.randomY = g.y;

    c.addChild(g);
    m.bc.sub.push(g);
    c.sub.push(g);
  });

  c.alpha = 0;

  app.stage.addChild(c);
  c.interactive = true;
  Array.from(c.sub).forEach((x) => {
    x.g.filters = [blurFilter(x.g.noFill ? 2 : x.g.size * 0.05)];
  });
  c.mouseover = () => {
    Array.from(c.sub).forEach((x) => {
      const f = { filter: 1 };
      x.g.spread();
      x.tweenFilter = new TWEEN.Tween(f)
        .to({ filter: 0 }, 200)
        .onUpdate(() => {
          if (f.filter) {
            x.g.filters = [blurFilter(f.filter)];
          } else {
            x.g.filters = null;
          }
        })
        .start();
    });
    c.alpha = 1;
    m.accX *= 4;
    m.accY *= 4;
  };
  c.mouseout = () => {
    Array.from(c.sub).forEach((x) => {
      x.g.unspread();
      x.tweenFilter.stop();
      x.g.filters = [blurFilter(x.g.noFill ? 2 : x.g.size * 0.05)];
    });
    // c.alpha = 0.8;
    m.generateAcc();
  };
  m.container = c;
  m.generateAcc = () => {
    m.i = 0;
    // m.accX = rand(-0.1, 0.1);
    // m.accY = rand(-0.1, 0.1);
    m.accX = 0;
    m.accY = 0;

    // if (Math.abs(m.container.x) <= 100) {
    //   const accX = (mouse.x - m.bc.g.x) / app.renderer.width;
    //   if (accX * m.container.x > 0 && m.container.x < 100) {
    //     m.accX = accX;
    //   } else if (accX * m.container.X < 0) {
    //     m.accX = accX;
    //   } else {
    //     m.accX = 0;
    //   }
    // }
    // if (Math.abs(m.container.y) <= 100) {
    //   const accY = (mouse.y - m.bc.g.y) / app.renderer.height;
    //   if (accX * m.container.x > 0 && m.container.x < 100) {
    //     m.accX = accX;
    //   } else if (accX * m.container.X < 0) {
    //     m.accX = accX;
    //   } else {
    //     m.accX = 0;
    //   }
    // }
  };
  m.generateAcc();
});

// 主要的球 END


// 動畫處理
// 第一階段球衝出去
app.stage.addChild(bc1);
app.stage.addChild(bc2);
let time = 0;
balls = balls.sort((a, b) => a - b);
const particleAnimation = () => {
  Array.from(balls).forEach((b, i) => {
    if (time++ > 50 * i) {
      // const r = rand(5 * ratio, 20 * ratio);
      const r = 20;
      b.x += r * b.accX;
      b.y += r * b.accY;
      // b.x += rand(5 * ratio, 20 * ratio) * b.accX;
      // b.y += rand(5 * ratio, 20 * ratio) * b.accY;
      // b.x += 10 * b.accX;
      // b.y += 10 * b.accY;
      b.scale.set(b.scale.x + 0.01);
      b.alpha += 0.1;
    }
  });
  Array.from(menu).forEach((m) => {
    if (m.container.alpha < 1) {
      m.container.alpha += m.container.alpha === 0 ? 0.001 : 0.001 * m.container.alpha * 50;
    }
  });
  if (Array.from(menu).map((x) => x.container.alpha).filter((x) => x === 1).length === menu.length) {
    app.ticker.remove(particleAnimation);
    app.stage.removeChild(bc1);
    app.stage.removeChild(bc2);
    app.stage.removeChild(bc3);
    app.stage.removeChild(bc4);
  }
};
app.ticker.add(particleAnimation);

// 主要的球進場與滑鼠效果

let animateIn = true;
app.ticker.add(() => {
  Array.from(menu).forEach(((m) => {
    if (m.i++ >= 5) {
      m.generateAcc();
    }

    if (animateIn && m.bc.x !== m.bc.originalX) {
      m.bc.x += (m.bc.originalX - m.bc.x) / 50;
    }
    if (!animateIn && m.bc.x !== m.bc.randomX) {
      m.bc.x += (m.bc.randomX - m.bc.x) / 50;
    }
    if (animateIn && m.bc.y !== m.bc.originalY) {
      m.bc.y += (m.bc.originalY - m.bc.y) / 50;
    }
    if (!animateIn && m.bc.y !== m.bc.randomY) {
      m.bc.y += (m.bc.randomY - m.bc.y) / 50;
    }
    Array.from(m.bc.sub).forEach((sub) => {
      if (animateIn && sub.x !== sub.originalX) {
        sub.x += (sub.originalX - sub.x) / 50;
      }
      if (!animateIn && sub.x !== sub.randomX) {
        sub.x += (sub.randomX - sub.x) / 50;
      }
      if (animateIn && sub.y !== sub.originalY) {
        sub.y += (sub.originalY - sub.y) / 50;
      }
      if (!animateIn && sub.y !== sub.randomY) {
        sub.y += (sub.randomY - sub.y) / 50;
      }
    });
  }));
});

// 從捲軸判斷要進場還出場

window.onscroll = (() => {
  const canvas = document.getElementById('canvas');
  const bound = canvas.getBoundingClientRect();
  if (bound.top < window.innerHeight) {
    app.start();
  }
  if (Math.abs(bound.top) < bound.height) {
    animateIn = true;
  } else {
    animateIn = false;
  }
});

app.ticker.add(() => {
  TWEEN.update(app.ticker.lastTime);
});

app.renderer.plugins.interaction.on('pointermove', (event) => {
  mouse.x = event.data.global.x;
  mouse.y = event.data.global.y;
  mouse.deltaX = mouse.x - mouse.oldX || 0;
  mouse.deltaY = mouse.y - mouse.oldY || 0;
  mouse.oldX = mouse.x;
  mouse.oldY = mouse.y;

  // Array.from(menu).forEach((m) => {
  //   // if (m.container.x > -50 && mouse.deltaX > 0) {
  //   // m.container.x += -1 * Math.sqrt(mouse.x - m.bc.g.x);
  //   // m.container.x += mouse.deltaX ;
  //   // } else if (m.container.x < 50 && mouse.deltaX < 0) {
  //   // m.container.x += -1 * Math.sqrt(mouse.x - m.bc.g.x);
  //   if ((m.container.x > -25 && mouse.deltaX > 0) || (m.container.x < 25 && mouse.deltaX < 0)) {
  //     m.container.x += Math.sqrt(Math.abs(mouse.deltaX)) * (mouse.deltaX > 0 ? -1 : 1);
  //   }
  //   if ((m.container.y > -12 && mouse.deltaY > 0) || (m.container.y < 12 && mouse.deltaY < 0)) {
  //     m.container.y += Math.sqrt(Math.abs(mouse.deltaY)) * (mouse.deltaY > 0 ? -1 : 1);
  //   }
  // }
  // if (m.container.y > -50 && mouse.deltaY > 0) {
  //   // m.container.x += -1 * Math.sqrt(mouse.y - m.bc.g.y) / 2;
  //   m.container.y += Math.abs(mouse.y - m.bc.g.y + m.bc.height / 2) * (mouse.deltaY > 0 ? -1 : 1) / app.renderer.height;
  // } else if (m.container.y < 50 && mouse.deltaY < 0) {
  //   // m.container.x += -1 * Math.sqrt(mouse.y - m.bc.g.y) / 2;
  //   m.container.y += Math.abs(mouse.y - m.bc.g.y + m.bc.height / 2) * (mouse.deltaY > 0 ? -1 : 1) / app.renderer.height;
  // }
  // });
});

// app.stop();

// title

// const title = new PIXI.Text('Capable', {
//   fontFamily: '"Futura", sans-serif',
//   fontSize: 120 * ratio,
//   fontWeight: 700,
//   fill: 0x336bd6,

// });
const title = PIXI.Sprite.fromImage('../images/capable-copy@3x.png');
title.x = app.renderer.width / 2 - title.width / 2 - 200;
title.y = 0.05 * app.renderer.height;
const subtitle = PIXI.Sprite.fromImage('../images/group-68.svg');
subtitle.x = app.renderer.width / 2 - 0.1 * title.width - 20;
subtitle.y = title.y + title.height - 0.5 * subtitle.height + 80;
app.stage.addChild(title);
app.stage.addChild(subtitle);
